import React from 'react';
import SvgIconBase from './SvgIconBase';
import { SvgIconProps } from '@mui/material/SvgIcon';

export const OperationsIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIconBase {...props}>
	<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M438-351.85 650.15-564l-42.77-42.77L438-437.38l-84.77-84.77-42.77 42.77L438-351.85Zm42 251.08q-129.77-35.39-214.88-152.77Q180-370.92 180-516v-230.15l300-112.31 300 112.31V-516q0 145.08-85.12 262.46Q609.77-136.16 480-100.77Zm0-63.23q104-33 172-132t68-220v-189l-240-89.62L240-705v189q0 121 68 220t172 132Zm0-315.62Z"/></svg>    
  </SvgIconBase>
);

export default OperationsIcon;